/** Back-confirm sheet — request a Prime callback. */
export const PRIME_ASSISTANT_WHATSAPP_CALLBACK_URL =
  'https://wa.me/919071178499?text=Hi%2C%20I%E2%80%99d%20like%20a%20callback%20to%20know%20more%20about%20Prime.'

/** Landing FAB — Elite Prime membership query. */
export const PRIME_ASSISTANT_WHATSAPP_FAB_URL =
  'https://wa.me/919071178499?text=I%20have%20a%20query%20about%20Elite%20Prime%20membership.'

export const PRIME_ASSISTANT_ICON_SRC = '/images/elite-plans/elite-prime/back-sheet/prime-assistant.png'
